// TABLE_NAME: PlanesEstrategicosActividadesIndicadoresCuantitativosMetasTipos
export const NUMERIC = 1;
export const PERCENTAGE = 2;
